import { Spin } from "antd";
import React from "react";

const CommonLoader = () => {
  return (
    <div>
      <Spin size="large" tip="Processing..." />
    </div>
  );
};

export default CommonLoader;
